export const TaskPanelPageTranslations = {
  TASK_PANEL: {
    es: 'Panel de tareas',
    en: 'Task panel',
    cat: 'Panell de tasques',
    eus: 'Zereginen panela',
    pt: 'Painel de tarefas'
  }
};
